export const colors = {
    paragon: {
        100: '#d6e3f5',
        200: '#adc9ea',
        300: '#7aa8db',
        400: '#4b86c9',
        500: '#215aa8',
        600: '#19488d',
        700: '#133870',
        800: '#0d2850',
        900: '#071833',
    },

    sagitarius: {
        100: '#E6EFF5',
        200: '#B0CCDF',
        300: '#8AB4D0',
        400: '#337CAD',
        500: '#005B99',
        600: '#00538B',
        700: '#00416d',
        800: '#003254',
        900: '#002640',
    },

    info: {
        100: '#ccddf5',
        200: '#99bbeb',
        300: '#669ae0',
        400: '#3378d6',
        500: '#0056cc',
        600: '#0045a3',
        700: '#00347a',
        800: '#002252',
        900: '#000914',
    },

    success: {
        100: '#d9f2e3',
        200: '#b3e5c8',
        300: '#8cd9ac',
        400: '#66cc91',
        500: '#40bf75',
        600: '#33995e',
        700: '#267346',
        800: '#1a4c2f',
        900: '#06130c',
    },

    warning: {
        100: '#fffbe4',
        200: '#fff2ab',
        300: '#ffe86e',
        400: '#ffdd0c',
        500: '#ffcd00',
        600: '#d1a400',
        700: '#9d7b00',
        800: '#695200',
        900: '#342900',
    },

    danger: {
        100: '#FFEDEF',
        200: '#F599A4',
        300: '#f06677',
        400: '#eb4439',
        500: '#e6001c',
        600: '#b80016',
        700: '#8a0011',
        800: '#5c000b',
        900: '#170003',
    },

    neutral: {
        100: '#ebebeb',
        200: '#d6d6d6',
        300: '#c2c2c2',
        400: '#adadad',
        500: '#999999',
        600: '#7a7a7a',
        700: '#5c5c5c',
        800: '#3d3d3d',
        900: '#1f1f1f',
    },

    semantic: {
        100: '#FFFFFF',
        200: '#F8F9FD',
        400: '#ADADAD',
        500: '#2A3D4A',
        900: '#000000',
    },
};
